import { Component, Injectable, Input, OnInit, signal, WritableSignal } from '@angular/core';
import { AlertComponent, AlertType } from '../alert/alert.component';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';

export type ApplicationMessageCode =
  'applicationApproved'
  | 'applicationSigned'
  | 'applicationNotSigned'
  | 'applicationSent'
  | 'paymentSuccess'
  | 'error';

export interface Alert {
  title: string;
  content: string;
  type: AlertType;
}

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  public alerts: WritableSignal<Alert[]> = signal([]);

  constructor() {
  }

  public show(n: Alert): void {
    setTimeout(() => {
      this.alerts.update((arr) => {
        arr.push(n);
        return arr;
      });
    });
  }

  public hide(i: number): void {
    setTimeout(() => {
      this.alerts.update((arr) => {
        arr.splice(i, 1);
        return arr;
      });
    });
  }

  public showByApplicationCode(code?: ApplicationMessageCode): void {
    switch (true) {
      case code === 'applicationApproved': {
        this.show({
          type: 'success',
          title: 'Status wniosku:',
          content: 'Twój wniosek został zatwierdzony.'
        });
        break;
      }
      case code === 'applicationSigned': {
        this.show({
          type: 'success',
          title: 'Status wniosku:',
          content: 'Twój wniosek został podpisany.'
        });
        break;
      }
      case code === 'applicationNotSigned': {
        this.show({
          type: 'danger',
          title: 'Status wniosku:',
          content: 'Twój wniosek nie został podpisany.'
        });
        break;
      }
      case code === 'applicationSent': {
        this.show({
          type: 'success',
          title: 'Status wniosku:',
          content: 'Twój wniosek został wysłany.'
        });
        break;
      }
      case code === 'paymentSuccess': {
        this.show({
          type: 'success',
          title: 'Status wniosku:',
          content: 'Twoja płatnośc została zrealizowana.'
        });
        break;
      }
    }
  }
}

@Component({
  selector: 'app-alert-container',
  standalone: true,
  imports: [
    AlertComponent,
    CommonModule
  ],
  templateUrl: './alert-container.component.html'
})
export class AlertContainerComponent implements OnInit {

  @Input()
  public dismissible: boolean = true;

  constructor(public alertService: AlertService) {
  }

  public ngOnInit(): void {
    this.alertService.alerts.set([]);
  }
}
